import { render, staticRenderFns } from "./CombinationsProductDropdowns.vue?vue&type=template&id=78be3ea8&scoped=true"
import script from "./CombinationsProductDropdowns.vue?vue&type=script&lang=ts"
export * from "./CombinationsProductDropdowns.vue?vue&type=script&lang=ts"
import style0 from "./CombinationsProductDropdowns.vue?vue&type=style&index=0&id=78be3ea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78be3ea8",
  null
  
)

export default component.exports